import { Facebook } from "lucide-react";
import { LINKS } from "../lib/links";
import { TikTokIcon } from "./PlatformIcons";

export default function PlatformButtons({ prefix = "hero", className = "" }) {
  return (
    <div className={`flex flex-col sm:flex-row gap-4 ${className}`}>
      <a href={LINKS.facebook} target="_blank" rel="noreferrer" data-testid={`${prefix}-watch-facebook-button`}
        className="btn-primary font-medium px-8 py-4 flex items-center justify-center gap-2.5">
        <Facebook className="w-5 h-5" /> Watch on Facebook
      </a>
      <a href={LINKS.tiktok} target="_blank" rel="noreferrer" data-testid={`${prefix}-follow-tiktok-button`}
        className="btn-glass font-medium px-8 py-4 flex items-center justify-center gap-2.5">
        <TikTokIcon className="w-5 h-5" /> Follow on TikTok
      </a>
    </div>
  );
}
